<template>
  <div class="rt60">
    <!-- <top-nav></top-nav> -->
    <!-- <banner :child-data="fdata"></banner> -->
      <div style="height:650px;overflow:hidden" class="mainTop" :style="{ height: Mobile + 'px'}">
        <img v-if="!showMobile" src="productImg/dualchannel.jpg" alt="" class="mobile" style="width:100%;height:100%;position: relative;" :style="{ height: Mobile + 'px'}">
        <img v-if="showMobile" src="productImg/dualchannelMobile.jpg" alt="" class="mobile" style="width:100% !important;height:100%;position: relative;" :style="{ height: Mobile + 'px'}">
      </div>
    <!-- <div class="part_2" style="text-align: center; height: 840px; background: #f7f7f7;background: url(productImg/2.jpg)center; height: 979px;">
        <h2 style="color: #fff; font-size: 48px; padding-top: 130px; margin-top: 0;">高能效NPU的AI芯片</h2>
        <h4 style="width: 1150px;margin: 0 auto;font-size: 18px; color: #fff; margin-top: 50px; margin-bottom: 80px;line-height: 1.5;">
            RK1808 AI芯片CPU采用双核Cortex-A35架构，最高频率1.6GHz，VPU支持1080P常规视频格式的编码和解码，支持摄像头视频信号输入并内置了ISP。提供多种存储配置选择，用户仅需扩展功能底板即可快速实现项目研产
        </h4>
    </div> -->
    <div id="product-main" class="container">
      <div class="company-develop" data-ani>
        <div class="info-title">
            <span class="line"></span>
            <span class="title-text">产品参数</span>
            <span class="line"></span>
        </div>
        <div class="develop-main mobileScroll">
          <table class="table table-hover" id="table">
            <thead>
              <tr>
                <th width>功能</th>
                <th>描述</th>
                <th>可见光成像</th>
                <th>热成像</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="vertical-align: middle;width: 80px;">DRAM</td>
                <td class="tal" style="width: 100px;">DRAM</td>
                <td class="tal" style="width: 360px;">C308X</td>
                <td class="tal" style="width: 360px;"></td>
              </tr>
              <tr>
                <td style="vertical-align: middle;width: 80px;">SOC</td>
                <td class="tal" style="width: 100px;">DRAM类型</td>
                <td colspan="2">256M DDR3 X 2</td>
              </tr>
              <tr>
                <td style="vertical-align: middle;width: 80px;">Flash</td>
                <td class="tal" style="width: 100px;">Flash 类型</td>
                <td colspan="2">eMMC:4GB</td>
              </tr>
              <tr>
                <td rowspan="22" style="vertical-align: middle;width: 80px;">成像单元及要求</td>
                <td rowspan="4" class="tal" style="width: 100px;">传感器要求</td>
                <td class="tal">≥1/2.9 inch CMOS，分辨率1920*1080(200万像素）SC2232H</td>
                <td class="tal">非制冷（氧化钒非制冷型探测器）</td>
              </tr>
              <tr>
                <td class="tal">最大分辨：2688×1520@25fps（400万星光级）</td>
                <td class="tal">分辨率 384*288</td>
              </tr>
              <tr>
                <td class="tal"></td>
                <td class="tal">响应波长：8~14μm</td>
              </tr>
              <tr>
                <td class="tal"></td>
                <td class="tal">像元尺寸：17μm</td>
              </tr>
              <tr>
                <td rowspan="7" class="tal" style="width: 100px;">镜头参数</td>
                <td class="tal">f=3.83（YT10137-2MP+H59+IR0147）</td>
                <td class="tal">定焦无热化畸变</td>
              </tr>
              <tr>
                <td class="tal">F：2.4</td>
                <td class="tal">焦距：13mm</td>
              </tr>
              <tr>
                <td class="tal">视角:水平≥65°，</td>
                <td class="tal">MRAD（空间分辨率）：1.308</td>
              </tr>
              <tr>
                <td class="tal">TV畸变率<1%</td>
                <td class="tal">视场角：28.2°*21.3°</td>
              </tr>
              <tr>
                <td class="tal"></td>
                <td class="tal">近摄距离：3m/1.1m</td>
              </tr>
              <tr>
                <td class="tal"></td>
                <td class="tal">F值：1.1</td>
              </tr>
              <tr>
                <td class="tal"></td>
                <td class="tal">伪彩模式：白热、黑热、融合1、彩虹、融合2、铁红1、铁红2、深褐色、色彩1、色彩2、冰火、雨、红热、绿热、深蓝等18种</td>
              </tr>
              <tr>
                <td class="tal">定焦/自动调焦</td>
                <td class="tal">定焦</td>
                <td class="tal">定焦</td>
              </tr>
              <tr>
                <td class="tal">可见光成像亮度检测</td>
                <td class="tal">XB-L5CY1NBE-G1  兴帮维科</td>
                <td class="tal">/</td>
              </tr>
              <tr>
                <td rowspan="2" class="tal">IR cut</td>
                <td class="tal">IR-CUT</td>
                <td rowspan="2" class="tal">/</td>
              </tr>
              <tr>
                <td class="tal">自动切换-光敏二极管</td>
              </tr>
              <tr>
                <td class="tal">850nm红外补光</td>
                <td class="tal">/</td>
                <td class="tal">/</td>
              </tr>
              <tr>
                <td class="tal">光电系统设计</td>
                <td class="tal">COB  SC2232H/SC2235</td>
                <td class="tal">模组</td>
              </tr>
              <tr>
                <td class="tal">图像帧率（FPS)</td>
                <td class="tal">≥30Hz</td>
                <td class="tal">≥25Hz</td>
              </tr>
              <tr>
                <td class="tal">分辨率切换</td>
                <td class="tal">支持</td>
                <td class="tal">不支持</td>
              </tr>
              <tr>
                <td class="tal">画面翻转</td>
                <td class="tal">支持 水平镜像/垂直镜像/对角镜像</td>
                <td class="tal">支持 水平镜像/垂直镜像/对角镜像</td>
              </tr>
              <tr>
                <td class="tal">图像模式</td>
                <td class="tal">彩色(不支持弱光（夜视）黑白像）</td>
                <td class="tal">黑热/白热/伪彩</td>
              </tr>
              <tr>
                <td class="tal">监控环面功能设置</td>
                <td class="tal"> / </td>
                <td class="tal">色带设置，报警灵敏度设置，屏蔽区域设置</td>
              </tr>
              <tr>
                <td rowspan="3" style="vertical-align: middle;width: 80px;">图像功能</td>
                <td class="tal" style="width: 100px;">双光融合</td>
                <td colspan="2" class="tal">支持热成像通道融合可见光图像信息，提升热成像通道图像细节</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">画中画</td>
                <td colspan="2" class="tal">支持可见光通道以画中画形式叠加热成像通道画面</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">智能信息叠加</td>
                <td colspan="2" class="tal">支持可见光通道图像中叠加热成像信息（仅支持测温规则，测温值）</td>
              </tr>
              <tr>
                <td>智能功能</td>
                <td class="tal">联动报警</td>
                <td class="tal" colspan="2">支持联动白光报警、支持联动声音报警</td>
              </tr>
              <tr>
                <td rowspan="11" style="vertical-align: middle;width: 80px;">测温要求</td>
                <td class="tal" style="width: 100px;">发射率校正</td>
                <td class="tal"> / </td>
                <td class="tal">支持可调范围：0.1~1</td>
              </tr>
              <tr>
                <td rowspan="2" class="tal" style="width: 100px;">测温范围</td>
                <td rowspan="2" class="tal"> / </td>
                <td class="tal"> -10℃~50℃；</td>
              </tr>
              <tr>
                <td class="tal">体温准确测温范围：32℃～42℃ </td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">测温精度</td>
                <td class="tal"> / </td>
                <td class="tal">±0.5℃（测温精度（方案可选）：无黑体方案精度±0.5℃；加黑体方案精度±0.3℃）</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">测温距离</td>
                <td class="tal"> / </td>
                <td class="tal">5m~10m</td>
              </tr>
              <tr>
                <td rowspan="3" class="tal" style="width: 100px;">温度校正</td>
                <td rowspan="3" class="tal"> / </td>
                <td class="tal">支持外置黑体辅助</td>
              </tr>
              <tr>
                <td class="tal">自动校正</td>
              </tr>
              <tr>
                <td class="tal">手动校正</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">温度异常功能</td>
                <td colspan="2" class="tal">全屏测温，专家模式：10个点，10个框，1条线总计21个测温规则</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">测温报警</td>
                <td colspan="2" class="tal">内置喇叭，人体体温过高触发“体温异常，请复测体温”</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">人体测温</td>
                <td colspan="2" class="tal">支持AI人脸检测，多目标同时检测体温</td>
              </tr>
              <tr>
                <td rowspan="4" style="vertical-align: middle;width: 80px;">WIFI/BT</td>
                <td class="tal" style="width: 100px;">模组 or COB 型号</td>
                <td colspan="2" class="tal">RTL8189模组</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">USB or SDIO</td>
                <td colspan="2" class="tal">SDIO</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">天线</td>
                <td colspan="2" class="tal">外置单天线</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">UART</td>
                <td colspan="2" class="tal">预留，内置</td>
              </tr>
              <tr>
                <td rowspan="5" style="vertical-align: middle;width: 80px;">语音交互</td>
                <td class="tal" style="width: 100px;">支持语音交互</td>
                <td colspan="2" class="tal">预留</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">告警</td>
                <td colspan="2" class="tal">监控告警提示音</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">喇叭驱动</td>
                <td colspan="2" class="tal">外置D放大机</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">喇叭功率</td>
                <td colspan="2" class="tal">1.5W@8Ω</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">麦克风类型及数量</td>
                <td colspan="2" class="tal">模拟，驻极体，1PCS</td>
              </tr>
              <tr>
                <td rowspan="7" style="vertical-align: middle;width: 80px;">指示灯</td>
                <td rowspan="7" class="tal" style="width: 100px;">状态指示灯（网络，工作状态）</td>
                <td colspan="2" class="tal">红绿双色灯：</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">1：上电，无网络,未启动监控，红色常亮</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">2: 上电，无网络，监控已启动（本地存储）红色闪烁：亮500ms-熄灭1s</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">3：网络连接认证中：红色闪烁：300ms-300ms</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">4：网络认证成功，但无数据：绿色常亮</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">5：正常工作，网络通信中：绿色闪烁：亮300ms-300ms</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">6:  监控灯光告警：红绿交替闪烁</td>
              </tr>
              <tr>
                <td rowspan="2" style="vertical-align: middle;width: 80px;">本地视频存储</td>
                <td class="tal" style="width: 100px;">本地视频存储支持</td>
                <td colspan="2" class="tal">支持本地存储，无网络时，有有存储卡默认启动监控并本地存储；支持Micro SD/Micro SDHC/Micro SDXC卡((128GB或者256GB)断网本地存储及断网续传</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">远程切换云存储</td>
                <td colspan="2" class="tal">支持远程设定存储方式：本地/云；支持（96/86/77/76）I系列NVR接入，支持预览/回放，规则显示，报警事件上传，远程配置</td>
              </tr>
              <tr>
                <td rowspan="3" style="vertical-align: middle;width: 80px;">RTC</td>
                <td rowspan="3" class="tal" style="width: 100px;">RTC</td>
                <td colspan="2" class="tal">NTP服务器实现时间同步，默认为中国国家授时中心NTP服务器地址是“ntp.ntsc.ac.cn” </td>
              </tr>
              <tr>
                <td colspan="2" class="tal">支持本地手动设定时间</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">纽扣电池</td>
              </tr>             
              <tr>
                <td rowspan="10" style="vertical-align: middle;width: 80px;">网络功能</td>
                <td rowspan="3" class="tal" style="width: 100px;">主码流</td>
                <td colspan="2" class="tal">可见光: 50Hz: 25fps (1920 × 1080), 25fps (1280 × 960), 25fps (1280 × 720)</td>
              </tr>   
              <tr>
                <td colspan="2" class="tal">可见光：60Hz: 30fps (1920 × 1080), 30fps (1280 × 960), 30fps (1280 × 720)</td>
              </tr>   
              <tr>
                <td colspan="2" class="tal">热成像：25fps (160 × 120 (输出 320 × 240))</td>
              </tr>   
              <tr>
                <td rowspan="3" class="tal" style="width: 100px;">子码流</td>
                <td colspan="2" class="tal">可见光：50Hz: 25fps (704 × 576), 25fps (640 × 480)</td>
              </tr>   
              <tr>
                <td colspan="2" class="tal">可见光：60Hz: 30fps (704 × 480), 30fps (640 × 480)</td>
              </tr>   
              <tr>
                <td colspan="2" class="tal">热成像：25fps (160 × 120 (输出 320 × 240))</td>
              </tr> 
              <tr>
                <td class="tal">网络协议</td>
                <td colspan="2" class="tal">IPv4/IPv6,HTTP,HTTPS,802.1x,Qos,FTP,SMTP,UPnP,SNMP,DNS,DDNS,NTP,RTSP,RTCP,RTP,TCP,UDP,IGMP,ICMP,DHCP,PPPoE,Bonjour</td>
              </tr>
              <tr>
                <td class="tal">接口协议</td>
                <td colspan="2" class="tal">ONVIF(PROFILE S,PROFILE G),ISAPI,SDK,Ehome,GB28181</td>
              </tr>
              <tr>
                <td class="tal">最大预览路数</td>
                <td colspan="2" class="tal">10~20</td>
              </tr>
              <tr>
                <td class="tal">用户管理</td>
                <td colspan="2" class="tal">支持三级权限管理，管理员、操作员、普通用户</td>
              </tr>
              <tr>
                <td rowspan="7" style="vertical-align: middle;width: 80px;">接口</td>
                <td class="tal" style="width: 100px;">以太网</td>
                <td colspan="2" class="tal">FE*1 ，支持 IEEE802.3af，POE-PD</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">SD卡</td>
                <td colspan="2" class="tal">1个内置SD卡槽</td>
              </tr>
              <tr>
                <td rowspan="3" class="tal" style="width: 100px;">恢复出厂设置按键</td>
                <td colspan="2" class="tal">支持本地恢复出厂配置</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">通过手动按键恢复设备出厂配置。</td>
              </tr>
              <tr>
                <td colspan="2" class="tal">启动配置按键</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">客户端</td>
                <td colspan="2" class="tal">支持</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">浏览器</td>
                <td colspan="2" class="tal">支持Chrome18+, Firefox5.0+, Safari5.02+浏览器、支持中英双语</td>
              </tr>
              <tr>
                <td rowspan="3" style="vertical-align: middle;width: 80px;">供电/功耗</td>
                <td class="tal" style="width: 100px;">功耗</td>
                <td colspan="2" class="tal"><15W</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">适配器</td>
                <td colspan="2" class="tal">DC12V1A,2.0mm</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">POE</td>
                <td colspan="2" class="tal">IEEE802.3af，class 3</td>
              </tr>
              <tr>
                <td rowspan="4" style="vertical-align: middle;width: 80px;">工作环境要求</td>
                <td class="tal" style="width: 100px;">温度</td>
                <td colspan="2" class="tal">温度：5℃ ~40℃</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">湿度</td>
                <td colspan="2" class="tal">相对湿度(％)：小于95%无凝结</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">防护等级</td>
                <td colspan="2" class="tal">IP66</td>
              </tr>
              <tr>
                <td class="tal" style="width: 100px;">其他要求</td>
                <td colspan="2" class="tal">稳定测量体温使用环境：室内环境；室温：16℃~32℃ </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- <div>
      <img class="img100" src="img/NeuBoard/1.jpg" alt="">
      <img class="img100" src="img/NeuBoard/2.jpg" alt="">
      <img class="img100" src="img/NeuBoard/3.jpg" alt="">
      <img class="img100" src="img/NeuBoard/4.jpg" alt="">
      <img class="img100" src="img/NeuBoard/5.jpg" alt="">
    </div> -->
    <!-- <footer-bot></footer-bot> -->
  </div>
</template>

<script>
import "../../public/css/font-awesome.min.css";
import "../../public/lib/response_table.css";
import "../../public/lib/response_table.css";
import jQuery from "../../public/js/jquery.min.js";
import "../../public/lib/response_table.js";
import topNav from "../components/top";
import banner from "../components/banner";
import footerBot from "../components/footerBot";
import { mapMutations } from "vuex";

export default {
  name: "product",
  components: {
    topNav,
    banner,
    footerBot
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      showMobile: false,
      Mobile: 650,
      fdata: {
        h1: "Product",
        menu: "",
        h2: "AI on device for you all",
        style: {
          background:
            "url(../img/product/cpzx_banner@3x.jpg)  center top 100% no-repeat ",
          backgroundSize: "100% 100%"
        }
      }
    };
  },
  methods: {
    ...mapMutations(["editMenu"])
  },
  watch: {
    $route(to, from) {
      if (to.query.id) {
        this.menu = to.query.id;
        console.log(this.menu);
      } else {
        this.menu = "face";
      }
    }
  },
  mounted() {
    if (this.screenWidth < 480 || this.screenWidth === 480) {
      this.showMobile = true
      this.Mobile = window.screen.height
    }
    // jQuery("#table").basictable();
    this.editMenu("product");
    var Expand = (function() {
      var tile = $(".strips__strip");
      var tileLink = $(".strips__strip > .strip__content");
      var tileText = tileLink.find(".strip__inner-text");
      var stripClose = $(".strip__close");
      var expanded = false;
      var open = function() {
        var tile = $(this).parent();
        if (!expanded) {
          tile.addClass("strips__strip--expanded");
          tileText.css(
            "transition",
            "all .6s 1s cubic-bezier(0.23, 1, 0.32, 1)"
          );
          stripClose.addClass("strip__close--show");
          stripClose.css(
            "transition",
            "all .6s 1s cubic-bezier(0.23, 1, 0.32, 1)"
          );
          expanded = true;
        }
      };
      var close = function() {
        if (expanded) {
          tile.removeClass("strips__strip--expanded");
          tileText.css(
            "transition",
            "all 0.05s 0 cubic-bezier(0.23, 1, 0.32, 1)"
          );
          stripClose.removeClass("strip__close--show");
          stripClose.css(
            "transition",
            "all 0.2s 0s cubic-bezier(0.23, 1, 0.32, 1)"
          );
          expanded = false;
        }
      };
      var bindActions = function() {
        tileLink.on("click", open);
        stripClose.on("click", close);
      };
      var init = function() {
        bindActions();
      };

      return {
        init: init
      };
    })();
    Expand.init();
  }
};
</script>

<style scoped>
blockquote {
  border: none;
}

#navbar-main {
}

#product-main {
  padding-bottom: 30px;
}

h3 {
  color: #0085cb;
}

#headerwrap {
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#product-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}
@media screen and (max-width: 1366px) {
  .mainTop {
    height: 440px;
  }
}
@media screen and (max-width: 480px) {
  .mainTop {
    height: 650px;
  }
  #product-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/product/cpzx_banner@3x.jpg) no-repeat
      center;
    background-size: 100% 100%;
  }
      .mobile {
    width:auto !important;
    height: 100% !important;
  }
}

#product-main .product-info {
  /* padding: 50px 0px; */
  box-sizing: border-box;
}

#product-main .info-title,
#product-main .develop-title {
  margin-bottom: 10px;
  margin-top: 0px !important;
  /* color: white; */
  border-radius: 20px;
  padding: 10px;
  margin-bottom: 40px;
  /* background: orange; */
  border-radius: 24px;
  padding: 10px 30px;
  color: white;
  text-align: center;
  width: 100%;
}

#product-main .info-title {
  margin-top: 80px;
}
#product-main .info-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

#product-main .info-main img {
  width: 100%;
}

#product-main .info-title .title-text,
#product-main .develop-title .title-text {
  font-size: 30px;
  color: black;
}

.company-develop {
  width: 100%;
  margin: 0 auto;
  padding-top: 40px;
}

@media screen and (max-width: 480px) {
  .company-develop {
    width: 100%;
    margin: 0 auto;
  }
  .mobileScroll {
    width: 100%;
    overflow:scroll;
  }
}

.company-develop #myTabs {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.company-develop #myTabs li {
  flex: 1;
  text-align: center;
}

.case-core {
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 413px;
  transition: background-image 0.5s;
  margin-bottom: 60px;
  background-color: #08061e;
}

.case-core-list {
  height: 100%;
  width: 25%;
  float: left;
  border-right: 1px solid rgba(255, 255, 255, 0.4);
  padding: 100px 35px 0;
  position: relative;
  transition: all 0.5s;
  cursor: pointer;
}

.en .case-core-list {
  padding-top: 50px;
}

.case-core.cell1 .case-core-list {
  width: 100%;
  border-right: none;
}

.case-core.cell2 .case-core-list {
  width: 50%;
}

.case-core.cell3 .case-core-list {
  width: 33.33%;
}

.case-core-hover .case-core-list {
  padding-top: 62px;
  width: 20%;
}

.en .case-core-hover .case-core-list {
  padding-top: 20px;
}

.case-core-hover.cell2 .case-core-list {
  width: 33.3%;
}

.case-core-hover.cell3 .case-core-list {
  width: 25%;
}

.case-core-hover .case-core-list.current {
  width: 40%;
}

.case-core-hover.cell1 .case-core-list.current {
  width: 100%;
}

.case-core-hover.cell2 .case-core-list.current {
  width: 66.7%;
}

.case-core-hover.cell3 .case-core-list.current {
  width: 50%;
}

.case-core-list:last-of-type {
  border-right: none;
}

.case-core-list .case-logo {
  height: 58px;
  margin-bottom: 10px;
}

.case-core-list .case-title {
  font-size: 20px;
  line-height: 150%;
  margin-bottom: 10px;
  color: #fff;
}

.case-logo img {
  height: 100%;
  width: auto;
}

.case-summary h3 {
  font-size: 20px;
  color: #ffffff;
  line-height: 150%;
  margin-bottom: 15px;
}

.en .case-summary h3 {
  text-align: left;
}

.case-summary p {
  font-size: 14px;
  color: #ffffff;
  line-height: 150%;
  transition: all 0.5s;
  opacity: 0;
}

.case-core-list.current .case-summary p {
  opacity: 0.8;
}

.case-more-btn {
  height: 48px;
  width: 82px;
  /* background: rgba(0, 0, 0, 0.2) url(/sites/all/themes/yitu/images/more2.svg) */
  /* no-repeat center 18px; */
  border-radius: 24px;
  position: absolute;
  left: 35px;
  bottom: 70px;
  transition: all 0.5s;
  display: none;
}

.case-core-list.current .case-more-btn {
  opacity: 0;
}

.case-wrapper {
  padding: 80px 0;
  background: #fff;
}

.case-type {
  width: 140px;
  float: left;
}

.case-list {
  width: calc(100% - 140px);
  float: right;
}

.case-type .form-type-bef-link,
.case-type li {
  font-family: PingFangSC-Medium;
  color: #000000;
  width: 100%;
}

.case-type .form-type-bef-link a,
.case-type li a {
  color: #7f7f7f;
  padding: 12px 0 12px 24px;
  font-size: 18px;
  line-height: 150%;
  position: relative;
  width: 100%;
  display: block;
  transition: all 0.5s;
}

.case-type .form-type-bef-link a:before,
.case-type li a:before {
  position: absolute;
  content: "";
  display: block;
  width: 2px;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  background: #000;
  opacity: 0.1;
}

.case-type .form-type-bef-link a.active,
.case-type li.active a {
  color: #000;
}

.case-type .form-type-bef-link a.active:before,
.case-type li.active a:before {
  background-image: linear-gradient(-90deg, #6acaff 0%, #0b1cba 100%);
  opacity: 1;
}

.case-list ul {
  padding-left: 9px;
  margin-bottom: 0;
}

.case-list li {
  position: relative;
  width: 100%;
  background: #f4f5f9;
  padding: 60px;
  margin-bottom: 24px;
}

.case-list li h3 {
  font-size: 20px;
  color: #000000;
  margin-bottom: 20px;
}

.case-list li p {
  opacity: 0.7;
  font-size: 16px;
  color: #000000;
  line-height: 26px;
}

.case-list li span.type {
  display: block;
  height: 30px;
  padding: 0 10px;
  text-align: center;
  font-size: 16px;
  line-height: 28px;
  position: absolute;
  left: -9px;
  top: 12px;
  border-width: 1px;
  border-style: solid;
  background-color: #fff;
}

.case-list li span.type:before {
  content: "";
  display: block;
  width: 10px;
  height: 6px;
  position: absolute;
  left: -1px;
  bottom: -7px;
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 10px;
}

.case-list li span.type.yuanqu {
  color: #189583;
  border-color: rgba(24, 149, 131, 0.1);
}

.case-list li span.type.yuanqu:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-yq.svg); */
}

.case-list li span.type.lingshou {
  color: #e07f16;
  border-color: rgba(224, 127, 22, 0.1);
}

.case-list li span.type.lingshou:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-ls.svg); */
}

.case-list li span.type.yiliao {
  color: #0060ff;
  border-color: rgba(0, 96, 255, 0.1);
}

.case-list li span.type.yiliao:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-yl.svg); */
}

.case-list li span.type.anfang {
  color: #000aff;
  border-color: rgba(0, 10, 255, 0.1);
}

.case-list li span.type.anfang:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-af.svg); */
}

.case-list li span.type.jinrong {
  color: #a38f33;
  border-color: rgba(163, 143, 51, 0.1);
}

.case-list li span.type.jinrong:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-jr.svg); */
}

.case-list li span.type.aicity {
  color: #a95454;
  border-color: rgba(169, 84, 84, 0.1);
}

.case-list li span.type.aicity:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-other.svg); */
}

.case-list li span.type.others {
  color: #e55354;
  border-color: rgba(69, 84, 184, 0.1);
}

.case-list li span.type.others:before {
  /* background-image: url(/sites/all/themes/yitu/images/flag-other.svg); */
}

[class^="icon-"],
[class*=" icon-"] {
  font-family: icomoon;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body,
html {
  font-size: 100%;
  padding: 0;
  margin: 0;
}

*,
*:after,
*:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}

.clearfix:after {
  clear: both;
}

a {
  color: #2fa0ec;
  text-decoration: none;
  outline: 0;
}

a:hover,
a:focus {
  color: #74777b;
}

.htmleaf-container {
  margin: 0 auto;
  text-align: center;
  overflow: hidden;
}

.htmleaf-content {
  font-size: 150%;
  padding: 1em 0;
}

.htmleaf-content h2 {
  margin: 0 0 2em;
  opacity: 0.1;
}

.htmleaf-content p {
  margin: 1em 0;
  padding: 5em 0 0;
  font-size: 0.65em;
}

.bgcolor-1 {
  background: #f0efee;
}

.bgcolor-2 {
  background: #f9f9f9;
}

.bgcolor-3 {
  background: #e8e8e8;
}

.bgcolor-4 {
  background: #2f3238;
  color: #fff;
}

.bgcolor-5 {
  background: #df6659;
  color: #521e18;
}

.bgcolor-6 {
  background: #2fa8ec;
}

.bgcolor-7 {
  background: #d0d6d6;
}

.bgcolor-8 {
  background: #3d4444;
  color: #fff;
}

.bgcolor-9 {
  background: #ef3f52;
  color: #fff;
}

.bgcolor-10 {
  background: #64448f;
  color: #fff;
}

.bgcolor-11 {
  background: #3755ad;
  color: #fff;
}

.bgcolor-12 {
  background: #3498db;
  color: #fff;
}

.htmleaf-header {
  padding: 1em 190px;
  letter-spacing: -1px;
  text-align: center;
}

.htmleaf-header h1 {
  font-weight: 600;
  font-size: 2em;
  line-height: 1;
  margin-bottom: 0;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.htmleaf-header h1 span {
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
  display: block;
  font-size: 60%;
  font-weight: 400;
  padding: 0.8em 0 0.5em;
  color: #c3c8cd;
}

.htmleaf-demo a {
  color: #1d7db1;
  text-decoration: none;
}

.htmleaf-demo {
  width: 100%;
  padding-bottom: 1.2em;
}

.htmleaf-demo a {
  display: inline-block;
  margin: 0.5em;
  padding: 0.6em 1em;
  border: 3px solid #1d7db1;
  font-weight: 700;
}

.htmleaf-demo a:hover {
  opacity: 0.6;
}

.htmleaf-demo a.current {
  background: #1d7db1;
  color: #fff;
}

.htmleaf-links {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  font-size: 1.5em;
  text-align: center;
}

.htmleaf-links::after {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -1px;
  width: 2px;
  height: 100%;
  background: #dbdbdb;
  content: "";
  -webkit-transform: rotate3d(0, 0, 1, 22.5deg);
  transform: rotate3d(0, 0, 1, 22.5deg);
}

.htmleaf-icon {
  display: inline-block;
  margin: 0.5em;
  padding: 0;
  width: 1.5em;
  text-decoration: none;
}

.htmleaf-icon span {
  display: none;
}

.htmleaf-icon:before {
  margin: 0 5px;
  text-transform: none;
  font-weight: 400;
  font-style: normal;
  font-variant: normal;
  font-family: icomoon;
  line-height: 1;
  speak: none;
  -webkit-font-smoothing: antialiased;
}

.htmleaf-footer {
  width: 100%;
  padding-top: 10px;
}

.htmleaf-small {
  font-size: 0.8em;
}

.center {
  text-align: center;
}

.related {
  color: #fff;
  background: #333;
  text-align: center;
  font-size: 1.25em;
  padding: 0.5em 0;
  overflow: hidden;
}

.related > a {
  vertical-align: top;
  width: calc(100% - 20px);
  max-width: 340px;
  display: inline-block;
  text-align: center;
  margin: 20px 10px;
  padding: 25px;
  font-family: segoe ui, lucida grande, Helvetica, Arial, microsoft yahei,
    FreeSans, Arimo, droid sans, wenquanyi micro hei, hiragino sans gb,
    hiragino sans gb w3, fontawesome, sans-serif;
}

.related a {
  display: inline-block;
  text-align: left;
  margin: 20px auto;
  padding: 10px 20px;
  opacity: 0.8;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
  -webkit-backface-visibility: hidden;
}

.related a:hover,
.related a:active {
  opacity: 1;
}

.related a img {
  max-width: 100%;
  opacity: 0.8;
  border-radius: 4px;
}

.related a:hover img,
.related a:active img {
  opacity: 1;
}

.related h3 {
  font-family: microsoft yahei, sans-serif;
}

.related a h3 {
  font-weight: 300;
  margin-top: 0.15em;
  color: #fff;
}

.icon-htmleaf-home-outline:before {
  content: "\e5000";
}

.icon-htmleaf-arrow-forward-outline:before {
  content: "\e5001";
}

@media screen and (max-width: 50em) {
  .htmleaf-header {
    padding: 3em 10% 4em;
  }

  .htmleaf-header h1 {
    font-size: 2em;
  }
}

@media screen and (max-width: 40em) {
  .htmleaf-header h1 {
    font-size: 1.5em;
  }
}

@media screen and (max-width: 30em) {
  .htmleaf-header h1 {
    font-size: 1.2em;
  }
}

.strips {
  min-height: 50vh;
  text-align: center;
  overflow: hidden;
  color: #fff;
  width: 100%;
  position: relative;
}

.strips__strip {
  will-change: width, left, z-index, height;
  position: absolute;
  width: 25%;
  min-height: 46vh;
  overflow: hidden;
  cursor: pointer;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.strips__strip:nth-child(1) {
  left: 0;
}

.strips__strip:nth-child(2) {
  left: 15vw;
}

.strips__strip:nth-child(3) {
  left: 30vw;
}

.strips__strip:nth-child(4) {
  left: 45vw;
}

.strips__strip:nth-child(1) .strip__content {
  background: #244f75;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
  -webkit-animation-name: strip1;
  animation-name: strip1;
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

.strips__strip:nth-child(2) .strip__content {
  background: #60bfbf;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  -webkit-animation-name: strip2;
  animation-name: strip2;
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.strips__strip:nth-child(3) .strip__content {
  background: #8c4b7e;
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
  -webkit-animation-name: strip3;
  animation-name: strip3;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

.strips__strip:nth-child(4) .strip__content {
  background: #f8bb44;
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100%, 0);
  -webkit-animation-name: strip4;
  animation-name: strip4;
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

@media screen and (max-width: 760px) {
  .strips__strip {
    min-height: 12vh;
  }

  .strips__strip:nth-child(1) {
    top: 0;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(2) {
    top: 12vh;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(3) {
    top: 24vh;
    left: 0;
    width: 100%;
  }

  .strips__strip:nth-child(4) {
    top: 36vh;
    left: 0;
    width: 100%;
  }
}

.strips .strip__content {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-decoration: none;
}

.strips .strip__content:hover:before {
  -webkit-transform: skew(-30deg) scale(3) translate(0, 0);
  -ms-transform: skew(-30deg) scale(3) translate(0, 0);
  transform: skew(-30deg) scale(3) translate(0, 0);
  opacity: 0.1;
}

.strips .strip__content:before {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.05;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: skew(-30deg) scaleY(1) translate(0, 0);
  -ms-transform: skew(-30deg) scaleY(1) translate(0, 0);
  transform: skew(-30deg) scaleY(1) translate(0, 0);
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.ai_office {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: center;
}

.ai_office > img {
  width: 70px !important;
  height: 60px;
  margin-right: 20px;
}

.ai_office p:nth-child(2) {
  font-size: 16px !important;
  margin-bottom: 0;
  text-align: left;
}

.mainAi {
  display: flex;
  flex-wrap: wrap;
}

.ai_sec {
  width: 50%;
}

.ai_sec > p {
  font-size: 20px;
}

.strips .strip__inner-text {
  will-change: transform, opacity;
  position: absolute;
  z-index: 5;
  top: 50%;
  left: 50%;
  width: 70%;
  -webkit-transform: translate(-50%, -50%) scale(0.5);
  -ms-transform: translate(-50%, -50%) scale(0.5);
  transform: translate(-50%, -50%) scale(0.5);
  opacity: 0;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.strips__strip--expanded {
  width: 100%;
  top: 0 !important;
  left: 0 !important;
  z-index: 3;
  cursor: default;
}

@media screen and (max-width: 760px) {
  .strips__strip--expanded {
    min-height: 48vh;
  }
}

.strips__strip--expanded .strip__content:hover:before {
  -webkit-transform: skew(-30deg) scale(1) translate(0, 0);
  -ms-transform: skew(-30deg) scale(1) translate(0, 0);
  transform: skew(-30deg) scale(1) translate(0, 0);
  opacity: 0.05;
}

.strips__strip--expanded .strip__title {
  opacity: 0;
}

.strips__strip--expanded .strip__inner-text {
  opacity: 1;
  -webkit-transform: translate(-50%, -50%) scale(1);
  -ms-transform: translate(-50%, -50%) scale(1);
  transform: translate(-50%, -50%) scale(1);
}

.strips__strip--expanded .strip__inner-text p {
  font-size: 24px;
}

.strip__title {
  display: block;
  margin: 0;
  position: relative;
  z-index: 2;
  width: 100%;
  font-size: 40px;
  color: #fff;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

@media screen and (max-width: 760px) {
  .strip__title {
    font-size: 28px;
  }
}

.strip__close {
  position: absolute;
  right: 3vw;
  top: 3vw;
  opacity: 0;
  z-index: 10;
  -webkit-transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;
  -webkit-transition-delay: 0.5s;
  transition-delay: 0.5s;
}

.strip__close--show {
  opacity: 1;
  font-size: 30px;
}

.pw100 {
  width: 100%;
  margin-top: 10%;
}

@-webkit-keyframes strip1 {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip1 {
  0% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip2 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip2 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip3 {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip3 {
  0% {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-webkit-keyframes strip4 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes strip4 {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.rt60 {
  position: relative;
  top: -60px;
  margin-bottom: -60px;
}
.myBtn:active {
  background-color: unset !important;
  color: unset;
}
.myBtn:focus {
  outline: 0 !important;
}
#table {
    border: 1px solid #dee2e6;
}
.table th, .table td {
    border-right: 1px solid #dee2e6;
}
.table thead th {
    border-bottom: 0 !important;
}
.tal {
    text-align: left;
}
.img100 {
  width: 100%;
}
</style>